import { fetchReducer } from 'iqvia-shared';
import reduceReducers from 'reduce-reducers';

import apiNameEnums from '../../../Enums/apiNames';

const defaultState = {
  locale: 'en-US',
  messages: { key: 'value' },
};

const localization = (state = defaultState, { type }) => {
  switch (type) {
    default:
      return state;
  }
};

export default reduceReducers(localization, fetchReducer(apiNameEnums.GET_LOCALIZATION));



// WEBPACK FOOTER //
// ./src/Shared/CustomIntlProvider/reducers/index.js